/**
 * Scrolls a horizontal scroll-container by a relative delta, clamped to the
 * container's scroll range and issued as an absolute smooth scrollTo.
 *
 * The clamp must happen here, with an absolute scrollTo — not left to the
 * browser via a relative scrollBy. A relative smooth scroll issued while a
 * previous one is still animating composes with that scroll's pending target,
 * so repeated triggers (arrow clicks, a scroll-spy walking through sections)
 * stack deltas far past the range, and WebKit lets the programmatic smooth
 * scroll settle out of bounds — leaving the strip stuck overscrolled with
 * blank space before the first item and unresponsive controls (iOS Safari).
 * Clamping every scroll to the range also lets the next trigger pull an
 * already-stuck strip back in bounds.
 */
export const scrollByClamped = (container: HTMLElement, delta: number) => {
	const maxScrollLeft = container.scrollWidth - container.clientWidth;
	const target = Math.min(
		Math.max(container.scrollLeft + delta, 0),
		maxScrollLeft
	);
	if (target === container.scrollLeft) return;

	container.scrollTo({ left: target, behavior: 'smooth' });
};
